export default function buildResourcePath(path) {
    let appSubdirectory = window.app.subdirectory

    if (path.substr(0, 1) === '/') {
        path = path.substr(1, path.length)
    }

    if (appSubdirectory.substr(appSubdirectory.length - 1, 1) === '/') {
        appSubdirectory = appSubdirectory.substr(0, appSubdirectory.length - 1)
    }

    return appSubdirectory + '/' + path
}